import { createAsyncThunk } from "@reduxjs/toolkit";
import { authSilceName } from ".";
import server from "../../../config/server";

export const changePasswordAction = createAsyncThunk(`${authSilceName}/changePassword`, async (payload, thunkAPI) => {
  try {
    const response = await server.put("/app/user/password/change", payload);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || { message: "Đổi mật khẩu thất bại" });
  }
});
